import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from 'components/system/Paper';
import Page from 'components/system/Page';
import colors from 'styles/colors';

const JobErrorPage = ({ error }) => {
  let errorContent = (
    <Box data-test-id="error-message-container">
      <Typography variant="h5" color={colors.text.primary}>
        Something went wrong
      </Typography>
      <Typography variant="body2" sx={{ color: colors.text.tetriary, padding: '20px 0' }}>
        Please try again later.
      </Typography>
    </Box>
  );

  if (error.response.status === 404) {
    errorContent = (
      <Box data-test-id="error-not-found-container">
        <Typography variant="h5" color={colors.text.primary}>
          Job Not Found
        </Typography>
        <Typography variant="body2" sx={{ color: colors.text.tetriary, padding: '20px 0' }}>
          The Job you are looking for does not exist.
        </Typography>
      </Box>
    );
  }

  return (
    <Page  withBackButton sx={{ height: 'calc(100% - 190px)' }}>
      <Paper sx={{ height: '100%', marginTop: '40px' }}>
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            width: '100%',
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {errorContent}
        </Box>
      </Paper>
    </Page>
  );
};

export default JobErrorPage;
